import { render } from "./BaseRadio.vue?vue&type=template&id=5498ef5f&ts=true"
import script from "./BaseRadio.vue?vue&type=script&lang=ts"
export * from "./BaseRadio.vue?vue&type=script&lang=ts"

import "./BaseRadio.vue?vue&type=style&index=0&id=5498ef5f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__